import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "./Loader";

const inputStyle = {
  display: "block",
  width: "100%",
  padding: "8px 10px",
  marginBottom: "12px",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  fontSize: "14px",
};

const submitBtnStyle = {
  backgroundColor: "#2563eb",
  color: "white",
  padding: "10px 16px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  width: "100%",
  fontWeight: "600",
  marginTop: "10px",
};

const cancelBtnStyle = {
  backgroundColor: "#6b7280",
  color: "white",
  padding: "10px 16px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  width: "100%",
  fontWeight: "500",
  marginTop: "10px",
};

export default function AdminLocations() {
  const [locations, setLocations] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchLocation, setSearchLocation] = useState("");
  const [filterLocations, setFilterLocations] = useState([]);

  const navigate = useNavigate();

  const fetchLocations = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://api.pdf.tajgateways.com/api-v1/locations"
      );
      setLoading(false);
      setLocations(res.data); // only backend data
    } catch (err) {
      console.error("Error fetching locations:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this location?")) return;
    try {
      setLoading(true);
      const response = await axios.delete(
        `https://api.pdf.tajgateways.com/api-v1/locations/${id}`
      );
      console.log("handleDelete", response?.data?.message);
      setLoading(false);
      if (response?.status == 200) {
        toast.success(response?.data?.message, {
          theme: "colored",
        });
        fetchLocations();
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const handleSearchLocation = (e) => {
    const val = e.target.value;
    setSearchLocation(val);
    const filtered = locations.filter((loc) =>
      loc.title.toLowerCase().includes(val)
    );
    setFilterLocations(filtered);
  };

  const filteredData = filterLocations?.length > 0 ? filterLocations : locations

  return (
    <div
      style={{
        padding: "40px",
        background: "#f9fafb",
        minHeight: "100vh",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {loading && <Loader />}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <button
          onClick={() => navigate("/")}
          style={{
            backgroundColor: "#3498db",
            color: "white",
            padding: "8px 16px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          📊 Dashboard
        </button>
      </div>

      <div className="location-header">
        <div>
          <h1
            style={{
              fontSize: "2rem",
              fontWeight: "bold",
              marginTop: "0",
              marginBottom: "20px",
            }}
          >
            Manage Locations
          </h1>

          <button
            onClick={() => setShowForm(true)}
            style={{
              backgroundColor: "#2563eb",
              color: "white",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            + Add New Location
          </button>
        </div>
        <div>
          <input
            type="search"
            placeholder="Search Location..."
            className="search-input"
            name="searchLocation"
            value={searchLocation}
            onChange={(e) => handleSearchLocation(e)}
          />
        </div>
      </div>

      {showForm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "30px",
              borderRadius: "10px",
              width: "400px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <h2 style={{ marginBottom: "20px" }}>Add New Location</h2>

            <form
              onSubmit={async (e) => {
                e.preventDefault();

                const formData = new FormData();
                const title = e.target.title.value;
                const tag = e.target.tag.value;
                const description = e.target.description.value;
                const sic_price = e.target.sic_price.value;
                const pvt_price = e.target.pvt_price.value;
                // const transfer_price = e.target.transfer_price.value;
                const child_price = e.target.child_price.value;
                const adult_price = e.target.adult_price.value;
                const vip_price = e.target.vip_price.value;

                formData.append("title", title);
                formData.append("tag", tag);
                formData.append("description", description);
                formData.append("sic_price", sic_price);
                formData.append("pvt_price", pvt_price);
                // formData.append("transfer_price", transfer_price);
                formData.append("child_price", child_price);
                formData.append("adult_price", adult_price);
                formData.append("vip_price", vip_price);

                if (e.target.img?.files[0])
                  formData.append("img", e.target.img.files[0]);
                if (e.target.img1?.files[0])
                  formData.append("img1", e.target.img1.files[0]);
                if (e.target.img2?.files[0])
                  formData.append("img2", e.target.img2.files[0]);

                try {
                  setLoading(true);
                  const response = await axios.post(
                    "https://api.pdf.tajgateways.com/api-v1/locations",
                    formData,
                    {
                      headers: { "Content-Type": "multipart/form-data" },
                    }
                  );
                  setLoading(false);
                  console.log("Location added successfully!", response);
                  if (response?.status == 201 || response?.status == 200) {
                    toast.success("Location added successfully!");
                    setShowForm(false);
                    fetchLocations();
                  } else {
                    setLoading(false);
                    toast.error(response?.data?.message);
                  }
                } catch (err) {
                  console.error("Add error:", err);
                  setLoading(false);
                  toast.error("Failed to add location");
                }
              }}
              encType="multipart/form-data"
            >
              <input
                name="title"
                placeholder="Title"
                required
                style={inputStyle}
              />
              <input name="tag" placeholder="Tag" style={inputStyle} />

              {/* Separate Image Fields */}
              <label>Image 1</label>
              <input name="img" type="file" style={inputStyle} />

              <label>Image 2</label>
              <input name="img1" type="file" style={inputStyle} />

              <label>Image 3</label>
              <input name="img2" type="file" style={inputStyle} />

              <textarea
                name="description"
                placeholder="Description"
                style={inputStyle}
              />

              <input
                name="sic_price"
                type="number"
                placeholder="SIC Price"
                style={inputStyle}
              />
              <input
                name="pvt_price"
                type="number"
                placeholder="PVT Price"
                style={inputStyle}
              />
              <input
                name="child_price"
                type="number"
                placeholder="Child Price"
                style={inputStyle}
              />
              <input
                name="adult_price"
                type="number"
                placeholder="Adult Price"
                style={inputStyle}
              />
              {/* <input
                name="transfer_price"
                type="number"
                placeholder="Transfer Price"
                style={inputStyle}
              /> */}
              <input
                name="vip_price"
                type="number"
                placeholder="VIP Price"
                style={inputStyle}
              />

              <button type="submit" style={submitBtnStyle}>
                Save
              </button>
            </form>

            <button onClick={() => setShowForm(false)} style={cancelBtnStyle}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Locations Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "20px",
        }}
      >
        {filteredData?.map((loc) => (
          <div
            key={loc._id}
            style={{
              background: "white",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
              padding: "16px",
              cursor: "pointer",
            }}
            onClick={() => navigate(`/locations/${loc._id}`)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.08)";
            }}
          >
            <img
              src={
                loc.img
                  ? loc.img.startsWith("http")
                    ? loc.img
                    : `https://api.pdf.tajgateways.com${loc.img}`
                  : "/default.jpg"
              }
              alt={loc.title}
              style={{
                width: "100%",
                height: "160px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            <h3
              style={{
                marginTop: "12px",
                fontSize: "1.2rem",
                fontWeight: "600",
              }}
            >
              {loc.title}
            </h3>
            <p style={{ color: "#6b7280", fontSize: "0.9rem" }}>{loc.tag}</p>

            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/locations/${loc._id}?edit=true`);
              }}
              style={{
                background: "#facc15",
                color: "#000",
                border: "none",
                borderRadius: "6px",
                padding: "6px 12px",
                marginTop: "10px",
                marginRight: "8px",
                cursor: "pointer",
              }}
            >
              Edit
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(loc._id);
              }}
              style={{
                background: "#ef4444",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "6px 12px",
                cursor: "pointer",
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
